import { authApi } from "api/base";

const getAll = (params) =>
  authApi.get("/popups", {
    params,
  });

const create = ({
    mediaId,
    imageOrText,
    content,
    contentTC,
    contentSC,
    status,
    publishedDate,
  }) =>
  authApi.post(`/popups`, {
    mediaId,
    imageOrText,
    content,
    contentTC,
    contentSC,
    status,
    publishedDate,
  });

const update = ({
  id,
  mediaId,
  imageOrText,
  content,
  contentTC,
  contentSC,
  status,
  publishedDate,
}) =>
  authApi.put(`/popups`, {
    id,
    mediaId,
    imageOrText,
    content,
    contentTC,
    contentSC,
    status,
    publishedDate,
  });

const del = (id) => authApi.delete(`/popups/${id}`);

export {
  getAll,
  create,
  update,
  del,
};
